import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
	List,
	ListItem,
	ListItemText,
	DialogTitle,
	Dialog
} from '@material-ui/core';

import useQueryParams from '../../hooks/useQueryParams';

const useStyles = makeStyles({
	title: {
		fontSize: 15,
		paddingLeft: 14,
		fontWeight: 800,
		paddingBottom: 0,
	},
	paper: {
		minWidth: 250,
	}
});

export default function CreateTypeDialog(props) {
	const { onClose, open } = props;
	const classes = useStyles();
	// eslint-disable-next-line
	const [queryParams, setQueryParams] = useQueryParams();

	const handleSelectDialog = (type) => () => {
		setQueryParams({ [type]: 'true' });
		onClose();
	};

	return (
		<Dialog onClose={onClose} open={open} 
			classes={{ paper: classes.paper }}
		>
			<DialogTitle disableTypography className={classes.title}>Create:</DialogTitle>
			<List>
				<ListItem button onClick={handleSelectDialog('create-event')}>
					<ListItemText primary="New Event" />
				</ListItem>

				<ListItem button onClick={handleSelectDialog('create-todo')}>
					<ListItemText primary="New Todo List" />
				</ListItem>

				<ListItem button onClick={handleSelectDialog('create-birthdate')}>
					<ListItemText primary="New Birthdate" />
				</ListItem>
			</List>
		</Dialog>
	);
}